import moment from 'moment'
import generateRandomKey from 'utils/generateRandomKey'
import {
  SEND_ALERT,
  CLOSE_ALERT,
  CHANGE_CURRENT_WORKOUT,
  FETCHING_SUPPLEMENTS,
  FETCHING_SUPPLEMENTS_FAILED,
  FETCHED_SUPPLEMENTS,
} from '../constants'

const initialState = {
  alert: {
    open: false,
    message: null,
    type: 'error',
  },
  currentWorkout: {
    id: generateRandomKey(),
    date: moment().format('YYYY-MM-DD'),
  },
  supplements: {},
}

function app(state = initialState, action) {
  switch (action.type) {
    case SEND_ALERT:
      return { ...state, alert: { ...action.alert, open: true } }
    case CLOSE_ALERT:
      return { ...state, alert: { ...state.alert, open: false } }
    case CHANGE_CURRENT_WORKOUT:
      return {
        ...state,
        currentWorkout: state.workouts[action.id],
      }
    case FETCHING_SUPPLEMENTS:
      return { ...state, supplements: 'fetching' }
    case FETCHING_SUPPLEMENTS_FAILED:
      return { ...state, supplements: action.error }
    case FETCHED_SUPPLEMENTS:
      return { ...state, supplements: action.supplements }
    default:
      return state
  }
}

export default app



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js